import {Container} from '@/components/ui/container/Container'
import {OpsVettingURLParams} from '@/features/ops-vetting/types'
import {Divider} from '@/components/ui/divider/Divider'
import {useTheme} from 'styled-components'
import {useOutletContext} from 'react-router-dom'
import {ScrollArea} from '@/components/ui/scroll-area/ScrollArea'
import {Scrollbar} from '@/components/ui/scrollbar/Scrollbar'
import {ServiceProPhotosGrid} from '@/features/service-vetting/components/service-pro-photos-grid/ServiceProPhotosGrid'
import {useTranslation} from '@/translations/i18n'
import {ErrorBox} from '@/components/commons/error-box/ErrorBox'
import {AlertTriangleIcon} from '@/components/ui/icon/Icon'
import {ServiceProPhotosHeader} from '@/features/service-vetting/components/service-pro-photos-header/ServiceProPhotosHeader'
import {ServicesProPhotosOfferings} from '@/features/service-vetting/components/services-pro-photos-offerings/ServicesProPhotosOfferings'
import {ProPhotosSkeleton} from '@/features/submission-pro-photos-upload/components/pro-photos-skeleton/ProPhotosSkeleton'
import {ProPhotosGrid} from '@/features/submission-pro-photos-upload/components/pro-photos-grid/ProPhotosGrid'
import {ProPhotosTitle} from '@/features/submission-pro-photos-upload/components/pro-photos-title/ProPhotosTitle'
import {useGetServiceProPhotos} from '@/features/service-vetting/query/useGetServiceProPhoto'
import {ServiceVettingCriteriaGalleryUploadButtonProPhoto} from '@/features/service-vetting/components/service-vetting-criteria-gallery-upload-button-pro-photo/ServiceVettingCriteriaGalleryUploadButtonProPhoto'

export const ServiceProPhotos = () => {
    const {palette} = useTheme()
    const {t} = useTranslation()
    const {urlParams} = useOutletContext<{urlParams: OpsVettingURLParams}>()
    const {remappedData: service, isPending, isError} = useGetServiceProPhotos(urlParams.id)

    if (isPending || !service) {
        return (
            <ProPhotosSkeleton
                title={t('vetting:reordering:service:title')}
                description={t('vetting:reordering:service:description')}
                serviceTitle={t('vetting:reordering:offerings')}
            />
        )
    }

    if (isError) {
        return (
            <Container fullWidth>
                <ErrorBox icon={<AlertTriangleIcon />} title={t('errors:default')} />
            </Container>
        )
    }

    return (
        <ScrollArea scrollbar={<Scrollbar />}>
            <ServiceProPhotosHeader service={service} />

            <ProPhotosTitle
                uploadButton={
                    <ServiceVettingCriteriaGalleryUploadButtonProPhoto
                        serviceId={service.id}
                        galleryId={service.gallery.id}
                    />
                }
                imagesLength={service.gallery.images.length}
                serviceTitle={t('vetting:reordering:offerings')}
            />

            <Divider direction="horizontal" background={palette.neutral[300]} />

            <ProPhotosGrid
                leftSlot={<ServiceProPhotosGrid service={service} />}
                rightSlot={<ServicesProPhotosOfferings service={service} />}
            />
        </ScrollArea>
    )
}
ServiceProPhotos.displayName = 'ServiceProPhotos'
